var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "field" }, [
    _c("label", { staticClass: "label" }, [_vm._v("Company / Name")]),
    _c("div", { staticClass: "field has-addons" }, [
      _c(
        "div",
        { staticClass: "control is-expanded" },
        [
          _vm.customers
            ? _c(
                "multiselect",
                {
                  class: { "is-danger": _vm.$v.entity.customer.$error },
                  attrs: {
                    value: _vm.value,
                    "deselect-label": "Can't remove this value",
                    "track-by": "key",
                    label: "value",
                    placeholder: "Select a customer",
                    options: _vm.customers,
                    loading: _vm.isCustomerLoading,
                    "internal-search": false,
                    "options-limit": _vm.assetFilter.pageSize,
                    searchable: true,
                    "show-labels": false,
                    "allow-empty": true,
                  },
                  on: {
                    input: _vm.changeCustomer,
                    "search-change": _vm.searchCustomer,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "option",
                        fn: function (props) {
                          return [
                            _c("span", [_vm._v(_vm._s(props.option.value))]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2400269036
                  ),
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "has-text-danger",
                      attrs: { slot: "noResult" },
                      slot: "noResult",
                    },
                    [_vm._v("Customer not found.")]
                  ),
                ]
              )
            : _vm._e(),
          !_vm.$v.entity.customer.required
            ? _c("span", { staticClass: "help is-danger" }, [
                _vm._v("Company / name is required"),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c("p", { staticClass: "control" }, [
        !_vm.customerExists
          ? _c(
              "a",
              {
                staticClass: "button is-success tooltip",
                attrs: { "data-tooltip": "Add customer" },
                on: { click: _vm.addCustomer },
              },
              [_vm._m(0)]
            )
          : _vm._e(),
        _vm.customerExists
          ? _c(
              "a",
              {
                staticClass: "button is-primary tooltip",
                attrs: { "data-tooltip": "Edit customer" },
                on: { click: _vm.editCustomer },
              },
              [_vm._m(1)]
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-plus mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-pencil mdi-24px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }